import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../layouts/DashboardLayout';
import loginUser from '../../utils/authService';
import { CATEGORY_DELETE_URL, CATEGORY_IMAGE_URL, CATEGORY_LIST_URL } from '../../utils/Constant';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import axios from "axios";

const CategoryListPage = () => {
  const [categoryData, setCategoryData] = useState([]);
  const [isBidDeleted, setIsBidDeleted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [categoryIdToDelete, setCategoryIdToDelete] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const authToken = useSelector(state => state.token);

  async function fetchCategories() {
    try {
      const response = await fetch(CATEGORY_LIST_URL, {
        headers: {
          'Authorization': `Bearer ${authToken.token}`,
        },
        credentials: 'include',
      });
      const json = await response.json();
      setLoading(false);
      setCategoryData(json);
    } catch (err) {
      //console.log("err", err);
    }
  }

  useEffect(() => {
    if (authToken) {
      fetchCategories();
    } else {
      navigate('/login')
    }
  }, []);

  const handleDeleteCategory = (category) => {
    //console.log("delete", category)
    setCategoryIdToDelete(category._id);
    setCurrentCategory(category);
    setIsModalOpen(true);
  }
  //console.log(categoryData)
  const handleCloseModal = () => {
    setCategoryIdToDelete(null);
    setCurrentCategory(null);
    setIsModalOpen(false);
  };

  const handleConfirmDelete = async () => {
    try {
      await axios
        .delete(`${CATEGORY_DELETE_URL}/${categoryIdToDelete}`, {
          headers: {
            Authorization: `Bearer ${authToken.token}`,
          },
        })
        .then((response) => {
          // Check the status code to determine if the deletion was successful
          if (response.status === 200) {
            setIsBidDeleted(true);
            setTimeout(() => {
              setIsBidDeleted(false);
              handleCloseModal();
              fetchCategories();
            }, 1000);
          } else {
            console.error("Deletion failed. Status code:", response.status);
          }
        })
        .catch((error) => {
          console.error("Error deleting product:", error);
        });
    } catch (error) {
      console.error("Error deleting product:", error);
      // Handle other errors if needed
    }
  };

  const Modal = ({ isOpen, onClose, onDelete }) => {
    return (
      <div className={`modal1 ${isOpen ? "open" : ""}`}>
        <div className="modal1-overlay" onClick={onClose}></div>
        <div className="modal1-content">
          {!isBidDeleted ? (
            <>
              <p>Product Name : {currentCategory?.categoryName}</p>
              <p>Are you sure you want to delete?</p>

              <div className="button-container">
                <button className="cancel-button" onClick={onClose}>
                  Cancel
                </button>
                <button className="delete-button" onClick={onDelete}>
                  Delete
                </button>
              </div>
            </>
          ) : (
            <div class="alert alert-success" role="alert">
              Product Deleted Successfully!
            </div>
          )}
        </div>
      </div>
    );
  };


  return (
    <DashboardLayout>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Categories</h3>
          <div className="card-tools">
            <a className="btn btn-primary btn-sm" href="/categories/create">
              <i className="fas fa-plus"> </i>
              Add New Category
            </a>
          </div>
        </div>
        <div className="card-body table-responsive p-0">
          <table className="table table-striped projects">
            <thead>
              <tr>
                <th style={{ width: "5%" }} className="text-center">#</th>
                <th style={{ width: "12%" }} className="text-center">Image</th>
                <th style={{ width: "20%" }}>Category Name</th>
                <th style={{ width: "15%" }}>Slug</th>
                <th style={{ width: "10%" }}>Parent Category</th>
                <th style={{ width: "10%" }}>Total Products</th>
                <th style={{ width: "8%" }} className="text-center">Status</th>
                <th style={{ width: "10%" }} className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td className="text-center" colspan="9">
                    <div className="text-center">
                      <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              {!loading && categoryData.map((category, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <ul className="list-inline text-center">
                      <li className="list-inline-item text-center">
                        <img
                          alt=""
                          className="table-avatar"
                          src={`${CATEGORY_IMAGE_URL}/${category.categoryImage}`}
                        />
                      </li>
                    </ul>
                  </td>
                  <td>
                    {category.categoryName}
                  </td>
                  <td>{category.categorySlug}</td>
                  <td>{category.parentCategory ? category.parentCategory.categoryName : 'None'}</td>
                  <td>{/* You need to fetch and display the total products here */}</td>
                  <td className="project-state">
                    <span className="badge badge-success">Active</span>
                  </td>
                  <td className="project-actions text-right">
                    <a className="btn btn-primary btn-sm" href="/">
                      <i className="fas fa-eye"> </i>
                    </a>
                    <a className="btn btn-info btn-sm" href={`/categories/update/${category._id}`}>
                      <i className="fas fa-pencil-alt"> </i>
                    </a>
                    <a className="btn btn-danger btn-sm" onClick={() => handleDeleteCategory(category)}>
                      <i className="fas fa-trash"> </i>
                    </a>
                    <Modal
                      isOpen={isModalOpen}
                      onClose={handleCloseModal}
                      onDelete={handleConfirmDelete}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* /.card-body */}
      </div>
    </DashboardLayout>
  );
}

export default CategoryListPage;
